import { render, staticRenderFns } from "./QuotaWarning.vue?vue&type=template&id=59e6548e&scoped=true"
import script from "./QuotaWarning.vue?vue&type=script&lang=js"
export * from "./QuotaWarning.vue?vue&type=script&lang=js"
import style0 from "./QuotaWarning.vue?vue&type=style&index=0&id=59e6548e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e6548e",
  null
  
)

export default component.exports